// extracted by mini-css-extract-plugin
export var container = "header-module--container--3lNyw";
export var logo = "header-module--logo--3gIix";
export var svgElem1 = "header-module--svgElem1--3kn6e";
export var animateSvgStroke = "header-module--animateSvgStroke--1ker9";
export var animateSvgFill = "header-module--animateSvgFill--36yy8";
export var cls1 = "header-module--cls1--1qw_N";